/* eslint dot-notation:0 */
(function(angular) {
    'use strict';

    function getSpacerGif(iEndpoints = null) {
        var $q = angular.injector(['ng']).get('$q');
        var spacerGifPromise = $q.defer();
        var endpoints = iEndpoints || angular.injector(['um']).get('endpoints');

        if (!endpoints || !endpoints.spacerGif) {
            return spacerGifPromise.reject();
        }
        var spacerGif = new Image();
        spacerGif.onload = function() {
            spacerGifPromise.resolve();
        };
        spacerGif.onerror = function() {
            if (endpoints.ssoLogin) {
                window.location = endpoints.ssoLogin.url + encodeURIComponent(window.location);
            } else {  // this is actually a configuration error
                spacerGifPromise.reject();
            }
        };
        spacerGif.src = endpoints.spacerGif.url + '?t=' + Date.now();
        return spacerGifPromise.promise;
    }

    angular.module('um',
        [
            // angular libs
            'ngSanitize',
            'ngAnimate',

            // 3rd party libs
            'ui.router',
            'ui.select',
            'ui.bootstrap',
            'ui.bootstrap.datepicker',
            'ui.bootstrap.position',
            'ui.bootstrap.modal',
            'ui.bootstrap.dropdown',
            'ui.bootstrap.typeahead',
            'ui.bootstrap.accordion',
            'ui.bootstrap.collapse',
            'ui.bootstrap.buttons',
            'ui.bootstrap.tooltip',
            'pascalprecht.translate',
            'rzModule',

            // webtrekk modules
            'wtApp.wtDropdown',
            'wtQueryBuilder',
            'wtApp.dataService',
            'wtApp.wtFormatFilters',
            'wtApp.wtSelector',
            'wtApp.groupedFilterEngine',
            'wtApp.wtTracking',
            'colorpicker.module',
            'wtUi',

            // um modules
            'um.commonDirectives',
            'um.commonFilters',
            'um.commonServices',
            'um.roles',
            'um.users',
            'um.profile',
            'um.categories',
            'um.filters',
            'um.templates'
        ])
        .constant('GUM_CONST', {
            services: [
                {
                    name: 'Analytics',
                    id: 'Q3V2',
                    rights: {access: 1}
                },
                {
                    name: 'Analytics API',
                    id: 'AN_EX_API'
                },
                {
                    name: 'Segment Manager',
                    id: 'URM'
                },
                {
                    name: 'Marketing Automation',
                    id: 'MAC'
                },
                {
                    name: 'Data Streams',
                    id: 'RDS'
                }
            ],
            languages: [
                {
                    id: 'EN',
                    title: 'LANG_ENGLISH',
                    description: '',
                    active: true,
                    visible: true
                },
                {
                    id: 'DE',
                    title: 'LANG_GERMAN',
                    description: '',
                    active: true,
                    visible: true
                },
                {
                    id: 'ZH',
                    title: 'LANG_CHINESE',
                    description: '',
                    active: true,
                    visible: true
                }
            ],
            commaDigitMarkCountries: ['DE'], // Argentina, Austria, Brazil, Chile, Denmark, Germany, Greece, Indonesia, Italy, Netherlands (currency), Portugal, Romania, Russia, Slovenia, Turkey
            numberFormats: [
                {
                    numberFormatGrouping: '.',
                    numberFormatSeparator: ','
                },
                {
                    numberFormatGrouping: '',
                    numberFormatSeparator: ','
                },
                {
                    numberFormatGrouping: ',',
                    numberFormatSeparator: '.'
                },
                {
                    numberFormatGrouping: '',
                    numberFormatSeparator: '.'
                }
            ],
            adminRole: 'Admin',
            dpcmRole: 'Data Privacy Compliance Manager',
            tagIntegrationId: 'ST',
            emailPattern: /^[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?$/,
            passwordPattern: /^(?=.*\d)(?=.*[a-zäöüß])(?=.*[A-ZÄÖÜ])(?!.*\s)(?=.*[^A-ZÄÖÜa-zäöüß0-9]).{8,64}$/,
            defaultUserAttributes: {
                language: 'EN',
                numberFormatGrouping: ',',
                numberFormatSeparator: '.',
                theme: 'light',
                chartColors: [
                    '#0095dc',
                    '#9abf00',
                    '#e25d52',
                    '#e0cf53',
                    '#dd54c0',
                    '#3c660c',
                    '#36d0ff',
                    '#b353e0',
                    '#585858',
                    '#1a3743',
                    '#65e0b3',
                    '#a3a3a3'
                ]
            },
            accessLevels: {no: 0, full: 1, custom: 2},
            rarAccessLevels: {no: 0, view: 1, create: 2, share: 3, edit: 4, full: 5},
            'MSG': 'ShowMessage',
            'warn.role.name.alreadyExist': 'MSG.ROLE_NAME_ALREADY_EXISTS', // translate error messages from the um-service
            'warn.role.serviceAccounts.isEmpty': 'MSG.ROLE_SERVICE_ACCOUNTS_MISSING',
            'error.role.updateAdminRoleIsNotAllowed': 'MSG.EDIT_ADMIN_ROLE_PROHIBITED',
            'warn.role.subjectsIsEmptyIsNotAllowedForAdminRole': 'MSG.NO_USER_IN_ADMIN_ROLE_PROHIBITED',
            'warn.business.role.subjectsIsEmptyNotAllowedForAdminRole': 'MSG.NO_USER_IN_ADMIN_ROLE_PROHIBITED',
            'warn.subject.role.noActiveSubjectWithAdminRoleIsNotAllowed': 'MSG.USER_WITH_ADMIN_ROLE_REQUIRED',
            'warn.subject.lastName.toShortOrToLong,warn.subject.firstName.toShortOrToLong': 'MSG.LAST_AND_FIRST_NAME_TOO_SHORT_OR_LONG',
            'warn.subject.lastName.toShortOrToLong': 'MSG.LAST_NAME_TOO_SHORT_OR_LONG',
            'warn.subject.firstName.toShortOrToLong': 'MSG.FIRST_NAME_TOO_SHORT_OR_LONG',
            'warn.subject.loginName.alreadyExist': 'MSG.LOGIN_NAME_ALREADY_EXISTS',
            'warn.subject.oldPassword.notMatch': 'MSG.PASSWORD_WRONG',
            'warn.subject.globalAttributes.absent': 'MSG.PROFILE_UPDATE_FAILED',
            'warn.subject.password.isBlank': 'MSG.PASSWORD_INVALID',
            'warn.subject.oldPassword.isBlank': 'MSG.PASSWORD_WRONG',
            'warn.subject.selfdeletion.notAllowed': 'MSG.MAY_NOT_DELETE_SELF',
            'warn.subject.isLastAdmin': 'MSG.MAY_NOT_DELETE_ADMIN',
            'warn.subject.password.notValid': 'MSG.PASSWORD_REQUIREMENTS',
            'warn.role.deleteAdminRoleIsNotAllowed': 'MSG.DELETE_ADMIN_ROLE_NOT_ALLOWED'
        })

        /**
         * "XSRF" settings to allow the locally running analytics to connect to the remote stages
         */
        .config(['$httpProvider', function($httpProvider) {
            $httpProvider.xsrfWhitelistedOrigins.push(
                'https://suite-dev-01.nbg.webtrekk.com/um-service/',
                'https://suite-int-01.nbg.webtrekk.com/um-service/',
                'https://suite-qa.nbg.webtrekk.com/um-service/'
            );
        }])

        /**
         * Compile configuration
         */
        .config([
            '$compileProvider',
            function($compileProvider) {
                // Only links and 'javascript:;' usages allowed on hyperlinks.
                const defaultList = new RegExp($compileProvider.aHrefSanitizationWhitelist());
                const voidLink = new RegExp(/^javascript:;$/);
                const combinedList = new RegExp(`${defaultList.source}|${voidLink.source}`);
                $compileProvider.aHrefSanitizationWhitelist(combinedList);
            }
        ])

        .config(['$urlRouterProvider', '$stateProvider', '$httpProvider', '$translateProvider', '$translatePartialLoaderProvider', '$locationProvider',
            function($urlRouterProvider, $stateProvider, $httpProvider, $translateProvider, $translatePartialLoaderProvider, $locationProvider) {
                $httpProvider.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
                $locationProvider.hashPrefix('');

                $translateProvider.useLoader('$translatePartialLoader', {
                    urlTemplate: 'i18n/{part}/{lang}.json'
                });
                $translateProvider.useLoaderCache('$templateCache');
                $translateProvider.useSanitizeValueStrategy(null);

                // Translations
                $translatePartialLoaderProvider.addPart('main');
                $translatePartialLoaderProvider.addPart('myprofile');
                $translatePartialLoaderProvider.addPart('messages');
                $translatePartialLoaderProvider.addPart('roles');
                $translatePartialLoaderProvider.addPart('users');
                $translatePartialLoaderProvider.addPart('categories');
                $translatePartialLoaderProvider.addPart('filters');
                // $translatePartialLoaderProvider.addPart('filter');
                $translatePartialLoaderProvider.addPart('filter-engine/filter');
                $translatePartialLoaderProvider.addPart('selector');
                $translatePartialLoaderProvider.addPart('wt-ui/suite-container/menu');

                // default route
                $urlRouterProvider.otherwise('/profile/edit');

                // advanced angular routing
                $stateProvider
                    .state('main', {
                        'abstract': true,
                        url: '/',
                        breadcrumb: 'USER_MANAGEMENT',
                        controller: 'main.controller as main',
                        templateUrl: 'modules/main/main.html'
                    });

                $httpProvider.interceptors.push(['$injector', '$q', function($injector, $q) {
                    return {
                        response: function(successResponse) {
                            return successResponse;
                        },
                        responseError: function(errorResponse) {
                            switch (errorResponse.status) {
                                //FF case. status=-1, statusText="", data=null
                                case -1:
                                //IE case. Content-type null, response 0. Aborting...on cross domain requests
                                case 0:
                                // shiro case when configured
                                case 401:  // unauthorized
                                case 403:  // forbidden
                                // special case for PUT
                                case 405:  // method not allowed
                                    // if it is already a retry, go to login
                                    if (errorResponse.config.retry) {
                                        var endpoints = $injector.get('endpoints');
                                        if (endpoints && endpoints.ssoLogin) {
                                            window.location = endpoints.ssoLogin.url + encodeURIComponent(window.location);
                                        }
                                    } else {   // fetch spacerGif and retry
                                        return getSpacerGif().then(function () {
                                            var $http = $injector.get('$http');
                                            var retryConfig = _.cloneDeep(errorResponse.config);
                                            retryConfig.retry = 1;
                                            return $http(retryConfig);
                                        });
                                    }
                            }
                            return $q.reject(errorResponse);
                        }
                    };
                }]);
            }]);

// Bootstrap the app after the config file is loaded.

    function fetchConfiguration() {
        var $http = angular.injector(['ng']).get('$http');

        return $http.get('config.json').then(function(response) {
            angular.module('um').constant('endpoints', response.data.api.endpoints);

            return response.data.api.endpoints;
        });
    }

    function whoAmI(iEndpoints = null) {
        var $http = angular.injector(['ng']).get('$http');
        var endpoints = iEndpoints || angular.injector(['um']).get('endpoints');

        return $http(angular.copy(endpoints["apiWhoAmI"])).then(function(response) {
            var whoami = response.data;
            angular.module('um').constant('myself', {
                id: whoami.userId,
                firstName: whoami.firstName,
                lastName: whoami.lastName,
                loginName: whoami.loginName,
                language: whoami.language
            });
            angular.module('um').constant('myCompany', {
                id: whoami.companyId,
                name: whoami.companyName,
                loginNamePrefix: whoami.companyLoginNamPrefix
            });
            angular.module('um').constant('featureFlags', whoami.featureFlags);
        });
    }

    function bootstrapApp(endpoints) {
        angular.element(document).ready(function() {
            const injector = angular.bootstrap(document, ['um']);
            const requestService = injector.get('requestService');
            requestService.setEndpointConfigurations(endpoints);
        });
    }

    fetchConfiguration()
        .then((endpoints) => {
            return getSpacerGif(endpoints).then(() => endpoints);
        })
        .then((endpoints) => {
            return whoAmI(endpoints).then(() => endpoints);
        })
        .then(bootstrapApp);
})(window.angular);
